module.exports = __webpack_public_path__ + "static/media/nexter_medium.44acb5d1.webp";